export enum EthnicityEnum {
    HispanicOrLatinoDescription = 'Hispanic or Latino',
    HispanicOrLatino = 1,
    NotHispanicOrLatinoDescription = 'Not Hispanic Or Latino',
    NotHispanicOrLatino = 2,
}
